import SignIn from "../pages/Auth/SignIn";
import { Route } from "react-router";
import Signup from "../pages/Auth/Signup";
import Forgot from "../pages/Auth/Forgot";
import { getConfig } from "../config/runtimeConfig";

// E2E test pages - ONLY imported when E2E mode is enabled
const CustomComparisonE2E =
  getConfig("REACT_APP_E2E_MODE") === "true"
    ? require("../pages/E2E/CustomComparisonE2E").default
    : null;

/**
 * Unprotected routes (no authentication required)
 *
 * SECURITY: E2E test routes are conditionally registered ONLY when
 * REACT_APP_E2E_MODE=true. Production builds MUST NOT enable this flag.
 */
const UnProtectedRoutes = () => {
  const isE2EMode = getConfig("REACT_APP_E2E_MODE") === "true";

  return (
    <>
      <Route path="login" element={<SignIn />} />
      <Route path="signup" element={<Signup />} />
      <Route path="forgotpassword" element={<Forgot />} />

      {/* E2E Test Routes - ONLY available when REACT_APP_E2E_MODE=true */}
      {isE2EMode && CustomComparisonE2E && (
        <Route path="e2e/custom-comparison" element={<CustomComparisonE2E />} />
      )}
    </>
  );
};

export default UnProtectedRoutes;
